import React from 'react';
import cx from 'classnames';
import dayjs from 'dayjs';
import Link from 'next/link';
import PropTypes from 'prop-types';
import Button from '@/components/Button';
import ContentstackImage from '@/components/ContentstackImage';
import { useTranslation } from '@/hooks/translation';
import { articleType } from '@/types';
import { articleImage } from '@/utilities/articles/articleCard';
import { formatLocalDateSimple } from '@/utilities/datetime';
import styles from './articleListItemDesktop.module.scss';

const ArticleListItemDesktop = ({ article, className }) => {
  const { t } = useTranslation();
  return (
    <Link href={`/articles/${article.article_category}${article.url}`}>
      <a className='text-decoration-none h-100'>
        <div className={cx(className, 'd-flex justify-content-between')}>
          <div className={styles.leftColumn}>
            <span>{t(`articles.categories.${article.article_category}`)}</span>
            <small>{t("articles.published")} {formatLocalDateSimple(article?.publish_details.time)}</small>
            <p>{article.title}</p>
            <div className={cx(styles.headerDivider, 'mt-1')} />
            <p className={styles.articleDescription}>{article.article_description}</p>
          </div>

          <div className={styles.imageWrapper}>
            <ContentstackImage
              src={articleImage(article)}
              width={500}
            />
          </div>
        </div>
      </a>
    </Link>
  )
}

export default ArticleListItemDesktop;

ArticleListItemDesktop.propTypes = {
  article: articleType,
  className: PropTypes.string
}
